var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 25.5L38 24.55C38 22.3132 36.433 20.5 34.5 20.5C32.567 20.5 31 22.3132 31 24.55L31 25.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25.5L26.5 24.55C26.5 22.3132 24.933 20.5 23 20.5C21.067 20.5 19.5 22.3132 19.5 24.55L19.5 25.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 37.5C16.8862 37.5 15.5 36.1114 15.5 34.5C15.5 32.8886 16.8862 31.5 18.7 31.5L28 31.5L28 37.5L18.7 37.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 37.5C39.1138 37.5 40.5 36.1114 40.5 34.5C40.5 32.8886 39.1138 31.5 37.3 31.5L27.5 31.5L27.5 37.5L37.3 37.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 30.5V38.5",
    stroke: "#6C6C6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 30.5V38.5",
    stroke: "#6C6C6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 30.5V38.5",
    stroke: "#6C6C6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19L22 13.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 19L35.5 13.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorror);
export default __webpack_public_path__ + "static/media/Horror.036ef62759fa332069395605ce747fe6.svg";
export { ForwardRef as ReactComponent };